import R from 'app/assets/R'
import { BaseRow } from 'app/components/common/BaseRow'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  LeftSideBodLayout,
  RightSideBodLayout
} from './layouts'
import * as S from './styles'

const DashboardBodContainer: React.FC = () => {
  const { t } = useTranslation()

  const desktopLayout = (
    <BaseRow gutter={[8, 8]} justify={'space-between'} wrap={false}>
      <LeftSideBodLayout />
      <RightSideBodLayout />
    </BaseRow>
  )
  return (
    <S.ScrollWrapper>
      <S.HeadingTitlePage>
        <span>{t(R.strings.dashboard_bod)}</span>
      </S.HeadingTitlePage>
      {desktopLayout}
    </S.ScrollWrapper>
  )
}

export default DashboardBodContainer
